import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiBearerIam } from '~/services/api';
import { HttpData } from '~/utils/network/HttpData';
import { FileWithPath } from '@mantine/dropzone';

export type UserImportRequest = {
  file: FileWithPath;
};

export type UserImportResponse = {
  message: string;
};

export const useUserImport = (
  config?: UseMutationOptions<
    HttpData<UserImportResponse>,
    Error,
    UserImportRequest
  >
) => {
  return useMutation<HttpData<UserImportResponse>, Error, UserImportRequest>({
    mutationKey: ['user', 'import'],
    mutationFn: async (payload) => {
      const formData = new FormData();
      formData.append('file', payload.file);

      const response = await apiBearerIam({}).post<
        HttpData<UserImportResponse>
      >('/iam/user/v1/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    },
    ...config,
  });
};
